/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".centertext[_ngcontent-%COMP%]{text-align:center}.rightbutton[_ngcontent-%COMP%]{float:right}"];
export { styles as styles };
